// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"716":"61f70fed","758":"0ed407a9","810":"7bc0f866"}[chunkId] + ".chunk.css";
};